module.exports = __webpack_public_path__ + "img/logo-xpress-text.2ac379f5.png";